import React, { Component } from "react";
import { Button, Form, Modal, InputGroup } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import EquipmentApi from "../../api/EquipmentApi";
import DatePicker from "react-multi-date-picker";
import AuthService from "../../session/AuthService";
import { Toaster, toast } from "react-hot-toast";
import { Select } from "antd";

class CreateServiceRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {},
      colorChange: false,
      colorChange1: false,
    };
  }

  componentDidMount = () => {
    console.log("option in create data", this?.props, this?.state?.formValues);

    // this.props.Type
    if (
      this.props.editValue &&
      Object.keys(this.props.editValue).length > 0 &&
      this.props.option === "edit"
    ) {
      let form = { ...this.props.editValue };

      form["personused"] = parseInt(this.props.editValue.service_createdby);

      this.setState(
        {
          formValues: form,
          colorChange: true,
          colorChange1: true,
        },
        () => {
          console.log(
            "this.props.editValue",
            this.state.formValues,
            this.props.editValue,
          );
        },
      );
    } else if (this.props.comefrom === "vehicle" || "Building" || "Equipment") {
      this.setState(
        {
          colorChange: true,
          colorChange1: true,
        },
        () => {
          console.log("this.props.editValue", this.state.formValues);
        },
      );
    }
  };

  render() {
    const { formValues, colorChange, colorChange1 } = this.state;
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h5 style={{ fontWeight: "bolder" }}>
              {this.props.option === "edit"
                ? "Edit Service Record"
                : "Add Service Record"}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Service Title</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Title"
                autoFocus
                className="small-input"
                name="service_title"
                onChange={this.OnHandleChange}
                value={formValues.service_title}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Choose Date</Form.Label>
              <InputGroup>
                <DatePicker
                  disabled={AuthService.getUserTypeAdmin() === "3"}
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  value={formValues.service_date}
                  name="service_date"
                  onChange={(value) => this.handleDateChange(value)}
                  style={{
                    height: "35px",
                    backgroundColor: "#F3F4F1",
                    borderColor: "#F3F4F1",
                  }}
                />
                <InputGroup.Append>
                  <i
                    className="fa fa-calendar"
                    style={{
                      position: "absolute",
                      left: "15rem",
                      top: "10px",
                      color: "rgb(138, 188, 73)",
                    }}
                  ></i>
                </InputGroup.Append>
              </InputGroup>
            </Form.Group>

            <>
              <Form.Group className="mb-3 w-100 farm-cutomselect">
                <Form.Label>Resource</Form.Label>

                <Select
                  className="w-100 farm-cutomselect"
                  style={{
                    // width: "100%",
                    color: colorChange1 ? "black" : "#747c84",
                  }}
                  getPopupContainer={(e) => e.parentNode}
                  placeholder="Choose Resource"
                  value={
                    this.props.plusNew === true
                      ? Number(this.props.service_resourceId)
                      : this.props.comefrom === "serviceRecord"
                        ? Number(formValues.service_resourceId ?? 0) 
                        : Number(this.props.service_resourceId)
                  }
                  onChange={(value) =>
                    this.OnHandleChange({
                      target: { name: "service_resourceId", value },
                    })
                  }
                  disabled={this.props.comefrom !== "serviceRecord"}
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={[
                    { value: 0, label: "Choose Resource" },
                    ...(String(this.props.Type) === "1"
                      ? this.props.commonArrays.map((e) => ({
                          value: e.building_id,
                          label: this.capitalizeFirstLetter(e.building_name),
                        }))
                      : String(this.props.Type) === "2"
                        ? this.props.commonArrays.map((e) => ({
                            value: e.equipmentId,
                            label: this.capitalizeFirstLetter(e.equipmentName),
                          }))
                        : String(this.props.Type) === "3"
                          ? this.props.commonArrays.map((e) => ({
                              value: e.vehicle_id,
                              label: this.capitalizeFirstLetter(e.vehicle_name),
                            }))
                          : []),
                  ]}
                />
              </Form.Group>
            </>

            <div className="Border-line"></div>
            {String(this.props.Type) !== "1" && (
              <>
                <Form.Group
                  className="mb-2"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>
                    {this.props.Type !== "2"
                      ? "Odometer Reading"
                      : "Hour Meter"}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="Odometer Reading"
                    autoFocus
                    className="small-input"
                    name="meterReading"
                    onChange={this.OnHandleChange}
                    value={formValues.meterReading}
                    disabled={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </>
            )}

            {/* <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Person Performing the task</Form.Label>

              <select
                class="form-select form-select-sm"
                aria-label=".form-select-sm example"
                id="form-select-sm-employee"
                name="personId"
                value={
                  formValues?.isDealer === true ? "dealer" : formValues.personId
                }
                // value={formValues.personId}
                onChange={this.OnHandleChange}
                style={{ color: colorChange ? "black" : "#747c84" }}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              >
                <option selected>Choose Employee</option>

                {this.props.userList.map((e) => (
                  <option value={e.id}>
                    {e.firstName + (e.lastName ? " " + e.lastName : "")}
                  </option>
                ))}
                <option value="dealer">Dealer</option>
              </select>
            </Form.Group> */}

            <Form.Group className="mb-3 w-100 farm-cutomselect" >
              <Form.Label>Person Performing the task</Form.Label>

              <Select
                showSearch
                 getPopupContainer={(e) => e.parentNode}
                className="w-100 farm-cutomselect"
                placeholder="Choose Employee"
                value={
                  formValues?.isDealer === true ? "dealer" : formValues.personId ?? ""
                }
                disabled={AuthService.getUserTypeAdmin() === "3"}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) =>
                  this.OnHandleChange({
                    target: { name: "personId", value },
                  })
                }
                options={[
                      { value: "", label: "Choose Employee" },
                  ...(this.props.userList
                    ? this.props.userList.map((e) => ({
                        value: e.id,
                        label: `${e.firstName}${e.lastName ? " " + e.lastName : ""}`,
                      }))
                    : []),
                  { value: "dealer", label: "Dealer" },
                ]}
              />
            </Form.Group>

            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Hours Taken To Complete Service</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Services"
                autoFocus
                className="small-input"
                name="hourstoComplete"
                onChange={this.OnHandleChange}
                value={formValues.hourstoComplete}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Details
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="detailDescription"
                onChange={this.OnHandleChange}
                value={formValues.detailDescription}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>

            <Form.Group className="mb-3" controlId="formBasicNo">
              <Form.Label>Upload Service Record</Form.Label>
              <br />
              <div className="custom-file">
                {this.state.formValues.service_record_file ? (
                  <label htmlFor="customFile" className="file-label">
                    {this.state.formValues.service_record_file.name}
                  </label>
                ) : (
                  <label htmlFor="customFile" className="file-label">
                    {this.props.option === "edit" &&
                    this.props.editValue.orginalImageName !== null
                      ? this.props.editValue.orginalImageName
                      : "Upload Service Record"}
                  </label>
                )}

                <input
                  type="file"
                  id="customFile"
                  onChange={this.handlefile}
                  name="service_record_file"
                  accept=".pdf"
                  disabled={AuthService.getUserTypeAdmin() === "3"}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicNo">
              <Form.Label>Upload Image</Form.Label>
              <br />
              <div className="custom-file">
                {this.state.formValues.uploadImage?.name ? (
                  <label htmlFor="customFile" className="file-label">
                    {this.state.formValues.uploadImage.name}
                  </label>
                ) : (
                  <label htmlFor="customFile" className="file-label">
                    {this.props.option === "edit" &&
                    this.props.editValue.uploadOriginalName !== null
                      ? this.props.editValue.uploadOriginalName
                      : "Upload Image"}
                  </label>
                )}

                <input
                  type="file"
                  id="customFile"
                  onChange={this.handlefile}
                  name="uploadImage"
                  accept=".png, .jpg, .jpeg"
                  disabled={AuthService.getUserTypeAdmin() === "3"}
                />
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Cancel
            </Button>
            <Button variant="success" type="button" onClick={this.saveForm}>
              {this.props.option === "edit"
                ? "Edit Service Record"
                : "Add Service Record"}
            </Button>
          </Modal.Footer>
        </Modal>
        <Toaster />
      </>
    );
  }

  capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  handlefile = (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    let form = { ...this.state.formValues };
    form[event.target.name] = file;
    this.setState({
      formValues: form,
    });
  };

  handleDateChange = (date) => {
    if (date) {
      // Check if date is not null or undefined
      console.log("date", date.toString());

      let form = this.state.formValues || {}; // Provide a default empty object if formValues is not available

      form["service_date"] = date.toString();
      this.setState(
        {
          formValues: form,
        },
        () => {
          console.log("date", date.toString());
        },
      );
    }
  };

  OnHandleChange = (event) => {
    let form = { ...this.state.formValues };

    form[event.target.name] = event.target.value;

    if (event.target.name === "personId") {
      this.setState({
        colorChange: true,
      });

      if (event.target.value === "dealer") {
        form["isDealer"] = true;
      } else {
        form["isDealer"] = false;
      }
    } else if (event.target.name === "service_resourceId") {
      this.setState({
        colorChange1: true,
      });
    }
    this.setState({
      formValues: form,
    });
  };

  saveForm = () => {
    const { formValues } = this.state;

    console.log("formValues", this.state.formValues);

    if (this.props.option === "edit") {
      if (!formValues.service_title) {
        toast.error("Please Enter the Service Title");
      } else if (!formValues.service_date) {
        toast.error("Please Choose the Service Date");
      } else if (
        (!formValues.service_resourceId ||
          formValues.service_resourceId === "Choose Resource") &&
        this.props.showoption &&
        this.props.comefrom === "serviceRecord"
      ) {
        toast.error("Please Choose  the Resource");
      } else if (
        !formValues.personId ||
        formValues.personId === "Choose Employee"
      ) {
        toast.error("Please Choose the Person");
      } else {
        let formdata = new FormData();
        formdata.append(
          "servicerecord_Id",
          this.props.editValue.servicerecord_Id,
        );
        formdata.append("service_title", formValues.service_title);
        formdata.append("service_resourceId", formValues.service_resourceId);
        formdata.append("service_date", formValues.service_date);
        formdata.append("service_createdby", formValues.personused);
        formdata.append("service_updateBy", formValues.personused);
        // formdata.append("personTask", formValues.personTask);
        if (String(this.props.Type) !== "1") {
          formdata.append("meterReading", formValues.meterReading);
        }

        formdata.append("hourstoComplete", formValues.hourstoComplete);
        formdata.append("detailDescription", formValues.detailDescription);
        if (formValues.personId === "dealer") {
          formdata.append("isDealer", true);
          formdata.append("personId", AuthService.getUserId());
        } else {
          formdata.append("isDealer", false);
          formdata.append("personId", formValues.personId);
        }

        // formdata.append("servicerecord_Id" , this.props.editValue.servicerecord_Id)
        formdata.append("service_type", this.props.Type);
        formdata.append("group_id", AuthService.getUserId());

        if (formValues.service_record_file?.name) {
          formdata.append(
            "service_record_file",
            formValues.service_record_file,
          );
        }

        if (formValues.uploadImage?.name) {
          formdata.append("uploadImage", formValues.uploadImage);
        }
        if (this.props.comefrom === "task") {
          formdata.append("taskId", this.props.taskId);
        }

        EquipmentApi.editServiceRecord(formdata).then((response) => {
          if (response.data && response.data.message === "success") {
            this.props.openListofServiceRecord(response.data.data);
            this.props.handleClose();
            if (this.props.comefrom === "serviceRecord") {
              this.props.onLoad();
            }

            this.props.renderToast("Edit");
          }
        });
      }
    } else {
      if (!formValues.service_title) {
        toast.error("Please Enter the Service Title");
      } else if (!formValues.service_date) {
        toast.error("Please Choose the Service Date");
      } else if (
        (!formValues.service_resourceId ||
          formValues.service_resourceId === "Choose Resource") &&
        this.props.showoption &&
        this.props.comefrom === "serviceRecord"
      ) {
        toast.error("Please Choose  the Resource");
      } else if (
        !formValues.personId ||
        formValues.personId === "Choose Employee"
      ) {
        toast.error("Please Choose  the Person");
      } else {
        let formdata = new FormData();
        formdata.append("service_title", formValues.service_title);

        if (this.props.comefrom === "serviceRecord") {
          if (this.props.showoption) {
            formdata.append(
              "service_resourceId",
              formValues.service_resourceId,
            );
          } else {
            formdata.append(
              "service_resourceId",
              this.props.existingemployee.service_resourceId,
            );
          }
        } else {
          formdata.append("service_resourceId", this.props.service_resourceId);
        }

        if (this.props.comefrom === "task") {
          formdata.append("taskId", this.props.taskId);
        }

        if (formValues.uploadImage?.name) {
          formdata.append("uploadImage", formValues.uploadImage);
        }

        if (formValues.personId === "dealer") {
          formdata.append("isDealer", true);
          formdata.append("personId", AuthService.getUserId());
        } else {
          formdata.append("isDealer", false);
          formdata.append("personId", formValues.personId);
        }

        formdata.append("service_date", formValues.service_date);
        formdata.append("meterReading", formValues.meterReading);
        formdata.append("hourstoComplete", formValues.hourstoComplete);
        formdata.append("detailDescription", formValues.detailDescription);
        // formdata.append("isDealer", formValues.isDealer);
        // formdata.append("personId", formValues.personId);
        formdata.append("service_type", this.props.Type);
        formdata.append("group_id", AuthService.getUserId());

        if (formValues.service_record_file?.name) {
          formdata.append(
            "service_record_file",
            formValues.service_record_file,
          );
        }

        EquipmentApi.saveServiceRecord(formdata).then((response) => {
          if (response.data && response.data.message === "success") {
            this.props.handleClose();
            if (this.props.comefrom === "serviceRecord") {
              this.props.onLoad();
              this.props.openListofServiceRecord(response.data.data);
            } else {
              if (this.props.comefrom !== "task") {
                this.props.openListofServiceRecord(response.data.data);
              } else {
                this.props.openCompleteButton();
              }
            }

            this.props.renderToast("Create");
          }
        });
      }
    }
  };
}
export default CreateServiceRecord;
